<template>
	<v-container fluid class="pb-0">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat outlined class="pb-0 pt-0">
					<v-card-text class="pb-0">
						<v-row>
							<v-col class="pb-0 pt-0">
								<v-card-title class="d-flex justify-left align-center pa-2">
									{{ $t('titles.teachersOnCourse') }}</v-card-title
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pt-0">
								<TheTable
									:additional-filters="teachersPlannedCourseTable.additionalFilters"
									:default-sort="teachersPlannedCourseTable.defaultSort"
									:excel="false"
									:fields="teachersPlannedCourseTable.headers"
									:header-selection-key="'teachers-planned-course-headers'"
									:height="teachersPlannedCourseTable.height"
									:total-records="teachersPlannedCourseTable.total"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in teachersPlannedCourseTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="redirectClick(props.item.teacher.id, true)"
									>
										<td
											v-if="teachersPlannedCourseTable.selectedHeaders.includes('rbr')"
											@click="redirectClick(item.teacher.id, true)"
										>
											{{ key + 1 }}
										</td>
										<td
											v-if="teachersPlannedCourseTable.selectedHeaders.includes('full_name')"
											@click="redirectClick(item.teacher.id, true)"
										>
											{{ item.teacher.full_name }}
										</td>
										<td
											v-if="teachersPlannedCourseTable.selectedHeaders.includes('email')"
											@click="redirectClick(item.teacher.id, true)"
										>
											{{ item.teacher.email }}
										</td>
										<td
											v-if="teachersPlannedCourseTable.selectedHeaders.includes('phone')"
											@click="redirectClick(item.teacher.id, true)"
										>
											{{ item.teacher.phone }}
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'teachersPlannedCourse',
	components: { TheTable },
	props: {
		plannedCourseId: [String, Number],
	},
	emits: ['reloadParticipants'],
	data: function () {
		return {
			teachersPlannedCourseTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.rbr'),
						value: 'rbr',
						type: '',
						sortable: false,
						width: '50px',
						allowFilter: false,
					},
					{
						text: this.$t('fields.teacher'),
						value: 'full_name',
						type: '',
						sortable: false,
						allowFilter: true,
					},
					{ text: this.$t('fields.email'), value: 'email', type: '', sortable: false, allowFilter: true },
					{ text: this.$t('fields.phone'), value: 'phone', type: '', sortable: false, allowFilter: true },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
		};
	},
	methods: {
		redirectClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/teachers/' + id);
			} else {
				let routeData = this.$router.resolve('/teachers/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.teachersPlannedCourseTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.teachersPlannedCourseTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'teachers-planned-courses/' + this.plannedCourseId,
				request,
				(data, success) => {
					if (success) {
						vm.teachersPlannedCourseTable.items = data.items;
						vm.teachersPlannedCourseTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.teachersPlannedCourseTable.height = window.innerHeight - 350 + 'px';
		},
	},
	mounted() {
		let vm = this;
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$modalBus.$on('reloadTeachersOnCourse', () => {
			vm.reloadData(vm.teachersPlannedCourseTable.lastRequest);
		});

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
